import React from "react";
import "../App.css";
import Header from "./Header";
import TournamentDetailsBanner from "./TournamentDetailsBanner";
import TournamentDetailsCard from "./TournamentDetailsCard";
import Footer from "./Footer";

export default function TournamentDetails() {
  return (
    <>
      <Header link={"tournament"} />
      <TournamentDetailsBanner />
      <TournamentDetailsCard />
      <Footer />
    </>
  );
}
